import React from "react";
import { Wrench } from "lucide-react";
import { useAuth } from "../context/AuthContext";

// Barra fissa e ben visibile per gli Admin HR: quando la manutenzione è attiva,
// li avvisa che dipendenti e responsabili NON possono accedere al portale.
// Gli admin non vengono bloccati, quindi devono sapere che gli altri sì.
const MaintenanceAdminBanner = () => {
  const { user, maintenance } = useAuth();

  if (!user || user.role !== "admin" || !maintenance?.active) return null;

  return (
    <div
      data-testid="maintenance-admin-banner"
      className="relative w-full z-[60] bg-[#ff7e00] text-white shadow-[0_2px_12px_rgba(0,0,0,0.25)]"
    >
      <div className="max-w-[1200px] mx-auto px-4 py-2 flex items-center gap-3">
        <Wrench size={16} className="shrink-0 animate-pulse" />
        <p className="text-[12.5px] font-bold flex-1 leading-snug" data-testid="maintenance-admin-banner-msg">
          Modalità manutenzione ATTIVA — dipendenti e responsabili non possono accedere al portale.
          Solo gli amministratori possono operare.
          {maintenance?.eta ? <span className="hidden sm:inline font-semibold text-white/90"> · Ripristino stimato: {maintenance.eta}</span> : null}
        </p>
        <span className="hidden md:inline text-[11px] font-bold bg-white/20 rounded-full px-2.5 py-1 whitespace-nowrap">
          Disattivabile dal Superadmin
        </span>
      </div>
    </div>
  );
};

export default MaintenanceAdminBanner;
